export enum PlatformType {
    Windows = 'windows',
    Apple = 'apple',
    Android = 'android',
    Linux = 'linux',
    Web = 'web',
}